<template>
    <div class="tooltip-text"
          v-bind:class="{'tooltip-text--top' : position === 'top',
                         'tooltip-text--bottom' : position === 'bottom',
                         'tooltip-text--bottom-left' : position === 'bottom-left',
                         'tooltip-text--bottom-right' : position === 'bottom-right',
                         'tooltip-text--right' : position === 'right',
                         'tooltip-text--left' : position === 'left',
                         'tooltip-visible' : visible}">
        <div v-html="text"></div>
    </div>
</template>

<script>
    export default {
        name: 'Tooltip',
        props: {
            position: String,
            text : String,
            visible: Boolean
        },
    }
</script>

<style lang="scss">
    @import "../styles/layout/tooltips";
</style>